import React, { useState } from 'react';
import { Modal, IconButton, Box } from '@mui/material';
import Close from '@mui/icons-material/Close';
import {
  GuideModalContainer,
  GuideModalHeader,
  GuideModalHeaderTitle,
  GuideModalBody,
  GuideSection,
  GuideSectionLabel,
  GuideText,
  GuideDivider,
} from '../../lesson/groupLesson/GroupLessonStyled';

const TABS = [
  { key: 'door', label: '출입문' },
  { key: 'restriction', label: '출입 제한·상품 연결' },
  { key: 'time', label: '출입 시간' },
  { key: 'member', label: '회원별 출입문' },
];

const DoorGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🚪 출입문이란</GuideSectionLabel>
      <GuideText>
        안면인식 단말이 달린 문 하나가 출입문 하나입니다.<br /><br />
        • 회원은 <strong>구매한 상품이 여는 출입문</strong>만 지나갈 수 있습니다.<br />
        • 출입 제한이 없는 문은 <strong>유효한 회원권만 있으면 누구나</strong> 지나갈 수 있습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>➕ 출입문 추가</GuideSectionLabel>
      <GuideText>
        우측 상단 <strong>"출입문 추가"</strong>를 클릭합니다.<br /><br />
        <strong>필수 입력</strong><br />
        • 출입문명 — 예: 1층 정문, 골프존 게이트<br />
        • 단말 번호 — 단말 1대. 번호는 <strong>관리자에게 문의</strong>하세요.<br /><br />
        <strong>선택 입력</strong><br />
        • 메모, 출입 제한 설정 (기본 끔)<br /><br />
        저장하면 안면인식 장비에 단말 → 구역 → 출입그룹이 자동으로 만들어집니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>✏️ 수정</GuideSectionLabel>
      <GuideText>
        행 우측 연필 아이콘으로 출입문명, 메모, 단말 번호를 수정합니다.<br />
        출입 제한은 목록의 토글, 출입 시간은 목록의 시간 칩에서 바로 바꿉니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>👥 회원 보기</GuideSectionLabel>
      <GuideText>
        <strong>회원</strong> 칸의 인원수를 클릭하면 그 문의 출입권을 가진 회원 목록이 열립니다.<br />
        회원을 클릭하면 회원 상품 상세로 이동합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🗑️ 삭제</GuideSectionLabel>
      <GuideText>
        행 우측 휴지통 아이콘으로 삭제합니다. <strong>출입권을 가진 회원이 없을 때만</strong> 삭제할 수 있습니다.<br /><br />
        <strong>⚠️ 삭제하면 되돌릴 수 없습니다</strong><br />
        • 안면인식 장비의 출입그룹과 구역이 함께 삭제됩니다.<br />
        • 이 문에 연결돼 있던 상품 설정이 해제됩니다.<br />
        • 복구가 필요하면 <strong>본사에 문의</strong>해 주세요.
      </GuideText>
    </GuideSection>
  </>
);

const RestrictionGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🔓 출입 제한 없음 (기본)</GuideSectionLabel>
      <GuideText>
<strong>어떤 상품을 구매했든</strong> 유효한 회원권만 있으면 지나갈 수 있는 문입니다.<br /><br />
        • 상품마다 따로 연결할 필요가 없습니다.<br />
        • 상품 등록 화면에서 "항상 가능"으로 고정 표시됩니다.<br />
        • 정문·공용 구역처럼 누구나 들어가는 문에 사용합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔒 출입 제한 켬</GuideSectionLabel>
      <GuideText>
<strong>연결한 상품을 가진 회원만</strong> 지나갈 수 있는 문입니다.<br /><br />
        • 필라테스실, 골프존처럼 특정 상품 전용 구역에 사용합니다.<br />
        • 목록의 토글로 켜고 끕니다. 바꿔도 회원 계정을 다시 만들지 않습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔗 상품에 출입문 연결</GuideSectionLabel>
      <GuideText>
회원권 관리 &gt; 수강권/이용권/일일권 <strong>등록·수정 화면의 "출입설정" 카드</strong>에서 연결합니다.<br /><br />
        • 출입 제한이 켜진 문만 선택할 수 있습니다. 제한 없는 문은 항상 가능으로 고정됩니다.<br />
        • 연결을 바꾸면 <strong>이미 그 상품을 가진 회원</strong>에게도 반영됩니다. 회원이 많으면 몇 분에 걸쳐 순차 반영됩니다.<br />
        • 문을 하나도 연결하지 않은 상품의 회원은 제한 없는 문만 지나갈 수 있습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚠️ 주의사항</GuideSectionLabel>
      <GuideText>
        • 회원의 출입 기간은 <strong>그 문을 여는 유효 상품들의 기간을 합친 것</strong>입니다. 환불·만료·중지되면 자동으로 닫힙니다.<br />
        • 안면 등록은 회원당 한 번이면 됩니다. 문이 여러 개여도 얼굴을 다시 등록하지 않습니다.
      </GuideText>
    </GuideSection>
  </>
);

const TimeGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🕒 출입 시간 종류</GuideSectionLabel>
      <GuideText>
        문마다 둘 중 하나를 씁니다.<br /><br />
        • <strong>지점 공통</strong> — 매장 설정의 입장시간(영업시간)을 그대로 따릅니다. 기본값입니다.<br />
        • <strong>문별 설정</strong> — 이 문만의 요일별 입장시간을 따로 둡니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚙️ 문별 시간 설정</GuideSectionLabel>
      <GuideText>
        목록의 <strong>출입 시간</strong> 칩을 클릭해 요일별 시간을 입력합니다.<br /><br />
        • 처음 열면 지점 공통 시간이 채워져 있어 필요한 요일만 고치면 됩니다.<br />
        • 저장하면 안면인식 장비에 즉시 반영됩니다.<br />
        • 문별 설정을 끄면 다시 지점 공통 시간을 따릅니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>📅 휴무일</GuideSectionLabel>
      <GuideText>
        휴무일은 매장 설정 기준으로 <strong>모든 문에 공통</strong> 적용됩니다. 문별 휴무는 지원하지 않습니다.
      </GuideText>
    </GuideSection>
  </>
);

const MemberGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>👤 회원 한 명만 예외 두기</GuideSectionLabel>
      <GuideText>
        회원 상세 &gt; 상품 상세의 각 상품 카드에 있는 <strong>출입문 행</strong>에서 설정합니다.<br /><br />
        • 상품이 여는 문에 더해 <strong>문을 추가</strong>하거나, 상품이 여는 문 중 하나를 <strong>빼는</strong> 것이 가능합니다.<br />
        • 출입 제한이 켜진 문만 대상입니다. 제한 없는 문은 항상 가능이라 뺄 수 없습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>📌 적용 범위</GuideSectionLabel>
      <GuideText>
        • 설정은 <strong>그 회원이 가진 그 상품 1건</strong>에만 붙습니다. 같은 상품을 다시 구매하면 다시 설정해야 합니다.<br />
        • 상품 기간이 끝나면 예외도 같이 끝납니다.<br />
        • 저장 즉시 안면인식 장비에 반영됩니다.
      </GuideText>
    </GuideSection>
  </>
);

const TAB_CONTENT = {
  door: DoorGuide,
  restriction: RestrictionGuide,
  time: TimeGuide,
  member: MemberGuide,
};

const DoorGuideModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState('door');
  const TabContent = TAB_CONTENT[activeTab];

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <GuideModalContainer>
        <GuideModalHeader>
          <GuideModalHeaderTitle>출입문 관리 가이드</GuideModalHeaderTitle>
          <IconButton onClick={onClose} sx={{ color: '#fff', p: '4px' }}>
            <Close />
          </IconButton>
        </GuideModalHeader>

        <Box
          sx={{
            display: 'flex',
            borderBottom: '1px solid #e0e0e0',
            flexShrink: 0,
            backgroundColor: '#fafafa',
          }}>
          {TABS.map(tab => (
            <Box
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              sx={{
                flex: 1,
                textAlign: 'center',
                padding: '12px 0',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: activeTab === tab.key ? 700 : 500,
                fontFamily: 'Pretendard, sans-serif',
                color: activeTab === tab.key ? '#4AB3BC' : '#888',
                borderBottom: activeTab === tab.key ? '2px solid #4AB3BC' : '2px solid transparent',
                transition: 'all 0.15s ease',
                '&:hover': { color: '#4AB3BC', backgroundColor: '#f0f8f8' },
              }}>
              {tab.label}
            </Box>
          ))}
        </Box>

        <GuideModalBody>
          <TabContent />
        </GuideModalBody>
      </GuideModalContainer>
    </Modal>
  );
};

export default DoorGuideModal;
